import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '../service/AuthService';

const PublicRoute = ({ children }) => {
   const auth = getToken()
   return !auth ? children : <Navigate to='/admin' />
}

export default PublicRoute